import React from 'react';
import SmsThread from '../../components/sms/SmsThread';

// Per-customer Text tab. The chat-bubble thread + reply box now live in the
// shared <SmsThread/> so this view stays byte-for-byte in sync with the
// unified inbox (Communication -> Text). This tab is just the single-
// customer entry point into that shared component.
const TextTab = ({ customerId, facilityId }) => (
  <SmsThread customerId={customerId} facilityId={facilityId} />
);

export default TextTab;
